import { MAIN_CHAT_MODE } from '@littlebird/sdk';
import { toast } from 'sonner';

import { performAttributedSend } from '@/features/chat/chat-send';
import { NEW_CHAT_ID } from '@/utils/constants';
import { navigate } from '@/utils/navigation-service';

/** Sends the request to a new chat, where Littlebird asks what it needs and creates the routine */
export const startRoutineSetup = async (request: string) => {
  try {
    const dispatch = await performAttributedSend({
      threadId: NEW_CHAT_ID,
      mode: MAIN_CHAT_MODE,
      content: request.trim(),
      requestResponseAudio: false,
    });
    if (dispatch.createdThreadId)
      await navigate({
        to: '/chats/$chatId',
        params: { chatId: dispatch.createdThreadId },
      });
  } catch (error) {
    toast.error('Could not start routine setup. Please try again.');
    throw error;
  }
};
